<template>
  <v-autocomplete
    color="primary"
    hide-no-data
    v-model="suppliersSelected"
    :clearable="!unclearable"
    chips
    multiple
    deletable-chips
    small-chips
    :items="suppliersItems"
    :loading="suppliersLoading"
    :search-input.sync="suppliersSearch"
    item-text="Description"
    item-value="id"
    item-disabled="disabled"
    :label="noLabel ? '' : label ? label : $t('Supplier.ObjectName')"
    return-object
    :single-line="dense"
    :dense="dense"
    :hide-details="dense"
    :style="dense ? 'margin-left: auto; margin-right: auto' : ''"
  >
    <template v-if="errorHint" v-slot:message="{ key, message }">
      <div :class="key == 0 ? 'danger--text' : ''">
        {{ message }}
      </div>
    </template>
  </v-autocomplete>
</template>

<script>
import Suppliers from "@/api/suppliers";

export default {
  name: "SearcherSuppliers",

  props: {
    value: Array,
    suppliersDistrict: Object,
    noLabel: Boolean,
    dense: Boolean,
    unclearable: Boolean,
    disabledItems: Array,
    errorHint: Boolean,
    label: String,
  },

  computed: {
    suppliersItems() {
      return this.suppliers.map((supplier) => {
        const Description =
          supplier.supplier_code + " / " + supplier.supplier_name;
        const disabled = this.disabledItems
          ? this.disabledItems.find(
              (disabledItem) => disabledItem.id == supplier.id
            )
          : false;
        return Object.assign({}, supplier, { Description, disabled });
      });
    },
  },

  data: () => ({
    suppliers: [],
    suppliersLoading: false,
    suppliersSearch: "",
    suppliersSelected: [],
  }),

  mounted() {
    this.getSuppliersFromAPI();
  },

  methods: {
    getSuppliersFromAPI() {
      this.suppliersLoading = true;
      Suppliers.fetchAllForSelect({})
        .then(
          function (response) {
            if (response.data.status.isOK()) {
              this.suppliers = response.data.suppliers;
            }
            this.suppliersLoading = false;
          }.bind(this)
        )
        .catch(
          function () {
            this.suppliersLoading = false;
          }.bind(this)
        );
    },
  },

  watch: {
    value: {
      immediate: true, //初始赋值也调用
      handler() {
        this.suppliersSelected = this.value;
      },
    },
    suppliersSelected: {
      handler() {
        this.$emit("input", this.suppliersSelected);
      },
    },
  },
};
</script>
